import { __objRest, __spreadValues } from './chunk-D6FLC3TD.mjs';
import Avatar from '@mui/material/Avatar';
import CardMedia from '@mui/material/CardMedia';
import { jsx } from 'react/jsx-runtime';

var generateCloudinarySrcSet = (url, widths = [400, 800, 1200]) => {
  try {
    const uploadIndex = url.indexOf("/upload/");
    if (uploadIndex === -1)
      return "";
    const baseUrl = url.substring(0, uploadIndex);
    const afterUpload = url.substring(uploadIndex + "/upload/".length);
    const versionMatch = afterUpload.match(/^v\d+\//);
    const version = versionMatch ? versionMatch[0] : "";
    const imagePath = versionMatch ? afterUpload.substring(versionMatch[0].length) : afterUpload;
    return widths.map((width) => {
      const transformedUrl = `${baseUrl}/upload/f_auto,q_auto,w_${width}/${version}${imagePath}`;
      return `${transformedUrl} ${width}w`;
    }).join(",\n    ");
  } catch (error) {
    console.error("Error generating Cloudinary srcSet:", error);
    return "";
  }
};
var isCloudinaryUrl = (url) => {
  if (!url) {
    return false;
  }
  return url.includes("cloudinary.com") && url.includes("/upload/");
};
var ResponsiveImage = (_a) => {
  var _b = _a, {
    src,
    alt,
    className = "",
    sizes = "(max-width: 768px) 400px, (max-width: 1200px) 800px, 1024px",
    widths = [400, 800, 1200],
    imgProps = {}
  } = _b, rest = __objRest(_b, [
    "src",
    "alt",
    "className",
    "sizes",
    "widths",
    "imgProps"
  ]);
  const isCloudinary = isCloudinaryUrl(src);
  return /* @__PURE__ */ jsx(
    "img",
    __spreadValues(__spreadValues({
      src,
      alt,
      className,
      loading: "lazy",
      sizes: isCloudinary ? sizes : void 0,
      srcSet: isCloudinary ? generateCloudinarySrcSet(src, widths) : void 0
    }, imgProps), rest)
  );
};
var ResponsiveCardMedia = (_a) => {
  var _b = _a, {
    src,
    alt,
    className,
    sizes = "(max-width: 768px) calc(100vw - 2rem), (max-width: 1200px) calc(50vw - 2rem), calc(33vw - 2rem)",
    widths,
    sx = {}
  } = _b, props = __objRest(_b, [
    "src",
    "alt",
    "className",
    "sizes",
    "widths",
    "sx"
  ]);
  return /* @__PURE__ */ jsx(
    CardMedia,
    __spreadValues({
      role: "img",
      component: "img",
      image: src,
      alt,
      className,
      sizes: isCloudinaryUrl(src) ? sizes : void 0,
      srcSet: isCloudinaryUrl(src) ? generateCloudinarySrcSet(src, widths) : void 0,
      sx: __spreadValues({
        width: "100%",
        height: "auto",
        aspectRatio: "16/9",
        objectFit: "cover"
      }, sx)
    }, props)
  );
};
var ResponsiveAvatar = (_a) => {
  var _b = _a, { src, alt, className, sizes, widths = [40, 80, 120] } = _b, props = __objRest(_b, ["src", "alt", "className", "sizes", "widths"]);
  const safeSrc = src != null ? src : "";
  const srcSet = isCloudinaryUrl(safeSrc) ? generateCloudinarySrcSet(safeSrc, widths) : void 0;
  return /* @__PURE__ */ jsx(
    Avatar,
    __spreadValues({
      src,
      alt,
      className,
      sizes: isCloudinaryUrl(src) ? sizes : void 0,
      srcSet
    }, props)
  );
};

export { ResponsiveAvatar, ResponsiveCardMedia, ResponsiveImage, generateCloudinarySrcSet, isCloudinaryUrl };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-BI277V2Z.mjs.map